import MODULE_KEYWORDS from 'components/Modules/keywords';

export const TRANSACTION_SIGNATURE_ACTION_FIELD_ID = 'transactionSignatureAction';
export const PENDING_TRANSACTIONS_DATASOURCE_ID = 20;

export const TRANSACTION_SIGNATURE_ACTION_FIELD = {
	id: TRANSACTION_SIGNATURE_ACTION_FIELD_ID,
	name: 'Firmar',
	width: 120,
	type: 'action',
	filterable: false,
	unselectable: true,
};

export function isInventoryTransactionsSubModule(selectedSubModule) {
	const { INVENTORY } = MODULE_KEYWORDS.MODULES.ITEMS.KEYS;
	return selectedSubModule?.key === INVENTORY.TRANSACTIONS.CONTROL;
}

export const isPendingTransactionsDatasource = selectedDataFilterId =>
	Number(selectedDataFilterId) === PENDING_TRANSACTIONS_DATASOURCE_ID;

export function addTransactionSignatureActionField(
	fields = [],
	selectedSubModule,
	disableTransactionSignatureAction = false,
) {
	if (disableTransactionSignatureAction) return fields;
	if (!isInventoryTransactionsSubModule(selectedSubModule)) return fields;
	if (fields.some(field => field.id === TRANSACTION_SIGNATURE_ACTION_FIELD_ID)) {
		return fields;
	}

	const indexFieldPosition = fields.findIndex(field => field.id === 'index');
	if (indexFieldPosition === -1) {
		return [TRANSACTION_SIGNATURE_ACTION_FIELD, ...fields];
	}

	return [
		...fields.slice(0, indexFieldPosition + 1),
		TRANSACTION_SIGNATURE_ACTION_FIELD,
		...fields.slice(indexFieldPosition + 1),
	];
}
